var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:['switch']},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.currValue},on:{"click":_vm.toggle}}),_c('span',{class:['switchSlider', 'round', _vm.darkTheme ? 'darkSlider' : 'lightSlider']})])}
var staticRenderFns = []

export { render, staticRenderFns }